/**
 * 동의일 표기 — 서버가 준 시각을 화면 글자로.
 *
 * 서버는 `Date` 를 주지만 tRPC 를 지나면 ISO 문자열로 도착한다. 화면이 쓰는 표기는
 * `2026.09.08` 이므로 그 사이를 여기 한 곳에서 옮긴다 — 화면마다 잘라 쓰면
 * 「2026-09-08」과 「2026.09.08」로 갈린다.
 *
 * 읽을 수 없는 값이면 `null` 을 준다. 그대로 넘기면 화면에 `Invalid Date` 가 찍힌다.
 */
export function toConsentDateLabel(occurredAt: string | null): string | null {
  if (occurredAt === null) {
    return null;
  }

  const parsed = new Date(occurredAt);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  return parsed.toISOString().slice(0, 10).replaceAll('-', '.');
}
